import { get, post, patch, deleted } from '../index'
import ProfileRoutes from './Profile.Routes';

const ProfileServices = {
  updatePicture: async (obj) => {
    const data = await post(ProfileRoutes.updatePicture, obj);
    return data
  },
  updateProfile: async (obj) => {
    const data = await patch(ProfileRoutes.updateProfile, obj);
    return data
  },
  getProfile: async () => {
    const data = await get(ProfileRoutes.getProfile);
    return data
  },
  PharmacyOrderList: async (page,rowsPerPage ,status,id,fromDate ,toDate) => {
    const data = await get(ProfileRoutes.PharmacyOrderList + `?page=${page}` + `&limit=${rowsPerPage}` + 
      `&status=${status}` + `&pharmacy_id=${id}` + `&from_date=${fromDate}` + `&to_date=${toDate}`);
    return data
  },
  PharmacyOrderUpdate: async (obj) => {
    const data = await patch(ProfileRoutes.PharmacyOrderUpdate ,obj);
    return data
  },
}

export default ProfileServices